export const chart_card_Style = {
  cardRootSx: {
    boxShadow: ' 0 1px 12px 0 rgb(0 0 0 / 0%), 0 6px 20px 0 rgb(0 0 0 / 3%)',
    borderRadius: '8px',
    backgroundColor: '#fff',
  },
};
